import React from 'react';
import ClipboardIcon from '../../../../assets/img/icons/clipboard.svg';


export interface StarterSetupProps {
	commands: string[]
	setupNote?: string
}


export default function StarterSetup({
	commands,
	setupNote,
}: StarterSetupProps) {
	function copyToClipboard() {
		navigator.clipboard.writeText(commands.join('\n'));
	}

	return (
		<section className="software-show__starter-setup">
			<h2 className="software-show__starter-setup-heading">Getting started</h2>

			{setupNote && (
				<p className="software-show__starter-setup-note">{setupNote}</p>
			)}

			<p>Run the following {commands.length > 1 ? 'commands' : 'command'}:</p>

			<div className="software-show__starter-commands">
				<ol className="software-show__starter-command-list">
					{commands.map((command, index) => (
						<li className="software-show__starter-command" key={`${index}-${command}`}>
							<span className="software-show__starter-command-prompt" aria-hidden="true">$</span>
							<code className="software-show__starter-command-code">{command}</code>
						</li>
					))}
				</ol>
				<button
					type="button"
					className="software-show__starter-command-copy"
					onClick={copyToClipboard}
					aria-label="Copy all setup commands"
				>
					<ClipboardIcon viewBox="0 0 1792 1792"/>
					<span>{commands.length > 1 ? 'Copy all' : 'Copy'}</span>
				</button>
			</div>
		</section>
	);
}
